export default __webpack_public_path__ + "static/media/zipper.f3476536.mp3";